/* eslint-disable no-console -- file defines debug logs */
export const debugLog: typeof console.log = (...args) => {
  // eslint-disable-next-line @opendoor/no-direct-env-check -- checking for production environment
  if (typeof window !== 'undefined' && window.ENV?.DEPLOY_ENV !== 'production') {
    console.log(...args);
    // eslint-disable-next-line n/no-process-env, @opendoor/no-direct-env-check -- checking for SSR first
  } else if (process.env.DEPLOY_ENV !== 'production') {
    console.log(...args);
  }
};

export const debugWarn: typeof console.log = (...args) => {
  // eslint-disable-next-line @opendoor/no-direct-env-check -- checking for production environment
  if (typeof window !== 'undefined' && window.ENV?.DEPLOY_ENV !== 'production') {
    console.warn(...args);
    // eslint-disable-next-line n/no-process-env, @opendoor/no-direct-env-check -- checking for SSR first
  } else if (process.env.DEPLOY_ENV !== 'production') {
    console.warn(...args);
  }
};

/**
 * @public
 */
export const debugTrace: typeof console.log = (...args) => {
  // eslint-disable-next-line @opendoor/no-direct-env-check -- checking for production environment
  if (typeof window !== 'undefined' && window.ENV?.DEPLOY_ENV !== 'production') {
    console.trace(...args);
    // eslint-disable-next-line n/no-process-env, @opendoor/no-direct-env-check -- checking for SSR first
  } else if (process.env.DEPLOY_ENV !== 'production') {
    console.trace(...args);
  }
};
